import React, { useState, useEffect, useMemo, useRef } from "react";
import Img from "../assets/secondPic.jpeg";
import secondImg from "../assets/thirdPic.png"
import thirdImg from "../assets/fourthPic.png"
import forthImg from "../assets/fifthPic.png"
import fifthImg from "../assets/sixthPic.png"
import sixthImg from "../assets/seventhPic.png"
import seventhImg from "../assets/eighthPic.png"
import eighthImg from "../assets/ninthPic.png"
import ninthImg from "../assets/eleventhPic.png"
import tenthImg from "../assets/twelvethPic.png"
import eleventhImg from "../assets/thirteenthPic.png"
import twelvethImg from "../assets/forteenthPic.png"
import thirteenthImg from "../assets/fifteenthPic.png"
import forteenthImg from "../assets/sixteenPic.png"
import fifteenthImg from "../assets/seventeenPic.png"
import sixteenthImg from "../assets/eighteenPic.png"
import seventeenthImg from "../assets/nineteenPic.png"
import eighteenImg from "../assets/twentyPic.png"
import logoImg from "../assets/Logo.jpeg";
import { Link } from "react-router-dom";
import '../styles/Instructions.css';
import Seo from './Seo';
import EnquiryModal from './EnquiryModal';
import LocationMap from './LocationMap';
import locations, { locationSchema } from '../data/locations';

export default function Instructions() {

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const [allImagesPreloaded, setAllImagesPreloaded] = useState(false);
  const [enquiryDate, setEnquiryDate] = useState(null);
  const datesSectionRef = useRef(null);
  const privateExperienceSectionRef = useRef(null);

  const WHATSAPP_NUMBER = '918279845322';

  const location = locations.gurugram;
  const gurugramSchema = locationSchema(location);

  // "DECEMBER" + 18 -> "18 December"
  const formatDate = date =>
    `${date.day} ${date.label.charAt(0)}${date.label.slice(1).toLowerCase()}`;

  const enquiryUrl = date => {
    const when = formatDate(date);
    const text = date.soldOut
      ? `Hi Mystery Mansion, the ${when} mystery at Gurugram shows as sold out. Could you let me know if a spot opens up or suggest another date?`
      : `Hi Mystery Mansion, I'm interested in being a part of the ${when} mystery at Gurugram. Could you share the availability?`;
    return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
  };

  const scrollToDates = () => {
    datesSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToPrivateExperience = () => {
    privateExperienceSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const showDates = [
    { month: 'DEC', day: 18, label: 'DECEMBER', image: fifthImg, soldOut: false },
    { month: 'DEC', day: 19, label: 'DECEMBER', image: fifthImg, soldOut: false },
    { month: 'DEC', day: 24, label: 'DECEMBER', image: fifthImg, soldOut: false },
    { month: 'DEC', day: 25, label: 'DECEMBER', image: fifthImg, soldOut: true },
  ];

  const navItems = [
    { name: "Home", href: "/" },
    { name: "The Game", href: "/#about-game" },
    { name: "Locations", href: "/#locations" },
    { name: "FAQs", href: "/#faqs" },
    { name: "Blog", href: "/blog" },
    { name: "The Architect", href: "/creator" }
  ];
  const propertyImages = useMemo(() => [
    secondImg,
    sixthImg,
    fifthImg,
    forthImg,
    seventhImg,
    Img,
    thirdImg,
    eighthImg,
    ninthImg,
    tenthImg,
    eleventhImg,
    forteenthImg,
    twelvethImg,
    thirteenthImg,
    fifteenthImg,
    sixteenthImg,
    seventeenthImg,
    eighteenImg
  ], []);


  useEffect(() => {
    const preloadImages = async () => {
      const imagePromises = propertyImages.map((src, index) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = () => resolve(src);
          img.onerror = reject;
          img.src = src;
        });
      });

      try {
        await Promise.all(imagePromises);
        setAllImagesPreloaded(true);
      } catch (error) {
        console.error('Error preloading images:', error);
        setAllImagesPreloaded(true);
      }
    };

    preloadImages();
  }, [propertyImages]);

  // Ensure the instructions page always opens scrolled to the top
  useEffect(() => {
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    } catch (e) {
      // fallback
      window.scrollTo(0, 0);
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMenuOpen && !event.target.closest('nav')) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [isMenuOpen]);

  const changeImage = (newIndex) => {
    if (newIndex !== currentImageIndex) {
      setCurrentImageIndex(newIndex);
    }
  };

  const nextImage = () => {
    const newIndex = currentImageIndex === propertyImages.length - 1 ? 0 : currentImageIndex + 1;
    changeImage(newIndex);
  };

  const prevImage = () => {
    const newIndex = currentImageIndex === 0 ? propertyImages.length - 1 : currentImageIndex - 1;
    changeImage(newIndex);
  };

  return (
    <div className="page-instructions">
      <EnquiryModal
        open={!!enquiryDate}
        heading={enquiryDate ? `Enquire about ${formatDate(enquiryDate)}?` : ''}
        body={enquiryDate
          ? (enquiryDate.soldOut
              ? `This date is currently sold out. We'll open WhatsApp with a message ready to send, and the organiser will let you know if a spot frees up.`
              : `We'll open WhatsApp with a message ready to send so the organiser can confirm availability for ${formatDate(enquiryDate)} at Gurugram.`)
          : ''}
        waUrl={enquiryDate ? enquiryUrl(enquiryDate) : '#'}
        onClose={() => setEnquiryDate(null)}
      />

      <Seo
        path="/gurugram"
        title="Things to Do in Gurgaon | Mystery Mansion Gurugram"
        description="Looking for unique things to do in Gurgaon? Experience Mystery Mansion, an immersive mystery game played during a private villa staycation with your group."
      >
        {gurugramSchema && (
          <script type="application/ld+json">{JSON.stringify(gurugramSchema)}</script>
        )}
      </Seo>


      {/* Navigation Bar */}
      <nav className="fixed top-0 left-0 right-0 z-50 mm-nav">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16 sm:h-18 md:h-20">
            <div className="flex-shrink-0">
              <Link to="/">
                <img
                  src={logoImg}
                  alt="Mystery Mansion Logo"
                  className="h-14 sm:h-16 md:h-20 w-auto cursor-pointer my-0"
                  style={{ filter: 'drop-shadow(0 0 20px rgba(201, 168, 76, 0.1))' }}
                />
              </Link>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-2">
                {navItems.map((item, index) => (
                  item.href.startsWith('#') || item.href.startsWith('/#') ? (
                    <a
                      key={index}
                      href={item.href}
                      className="mm-nav-link"
                    >
                      {item.name}
                    </a>
                  ) : (
                    <Link
                      key={index}
                      to={item.href}
                      className="mm-nav-link"
                    >
                      {item.name}
                    </Link>
                  )
                ))}
              </div>
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setIsMenuOpen(!isMenuOpen);
                }}
                className="focus:outline-none p-2"
                aria-label="Toggle menu"
                style={{ color: 'var(--text-secondary)' }}
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  {isMenuOpen ? (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  ) : (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                  )}
                </svg>
              </button>
            </div>
          </div>

          {/* Mobile Navigation Menu */}
          <div className={`md:hidden mm-mobile-menu ${isMenuOpen ? 'open' : ''}`}>
            <div className="px-2 pt-2 pb-3 space-y-0">
              {navItems.map((item, index) => (
                item.href.startsWith('#') || item.href.startsWith('/#') ? (
                  <a
                    key={index}
                    href={item.href}
                    className="mm-nav-link"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item.name}
                  </a>
                ) : (
                  <Link
                    key={index}
                    to={item.href}
                    className="mm-nav-link"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item.name}
                  </Link>
                )
              ))}
            </div>
          </div>
        </div>
      </nav>

      {/* Instructions Section */}
      <section className="instructions-section">
        <div className="desktop-layout">
          {/* Left side - Instructions content */}
          <div className="desktop-content">
            <h1
              className="font-bold desktop-title"
            >
              {"About The Property (Gurugram)".split('').map((letter, index) => (
                <span key={index} className="wavy-letter">
                  {letter === ' ' ? '\u00A0' : letter}
                </span>
              ))}
            </h1>

            <div className="desktop-list" style={{ fontFamily: "Avenir" }}>
              <div>4 bedrooms, 4 bathrooms—plenty of space to plot and prepare</div>
              <div>Indoor pool (open till 7:30pm) for a pre-mystery dive</div>
              <div>Pool table and games to test your strategy between clues</div>
              <div>In-home cinema for group debriefs</div>
              <div>BYOB — your drinks, our bar can brew suspense for you</div>
              <div>Dining available on order—fuel your next move</div>
              <div>Ideal for 8–12 guests, where camaraderie and secrets intertwine</div>
              <div>Check-in from 5pm, check-out by 10am</div>
            </div>


          </div>

          {/* Right side - Image Carousel */}
          <div className="desktop-carousel">
            {!allImagesPreloaded ? (
              <div className="carousel-container">
                <div className="loading-spinner">
                  <div className="spinner"></div>
                </div>
              </div>
            ) : (
              <div className="carousel-container">
                <button
                  onClick={prevImage}
                  className="carousel-arrow prev"
                  aria-label="Previous image"
                >
                  <svg className="carousel-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6" /></svg>
                </button>

                <div className="carousel-track" style={{ '--slide-count': propertyImages.length, '--current-index': currentImageIndex }}>
                  {propertyImages.map((image, index) => (
                    <div key={index} className="carousel-slide">
                      <img
                        src={image}
                        alt={`Luxury villa interior view ${index + 1}`}
                        className="carousel-image"
                        loading={index < 3 ? "eager" : "lazy"}
                      />
                    </div>
                  ))}
                </div>

                <button
                  onClick={nextImage}
                  className="carousel-arrow next"
                  aria-label="Next image"
                >
                  <svg className="carousel-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6" /></svg>
                </button>

                <div className="image-counter">
                  {currentImageIndex + 1} / {propertyImages.length}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Booking CTA Section */}
        <div style={{
          position: 'relative',
          zIndex: 10,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '1.5rem',
          paddingTop: '20px',
          paddingBottom: '60px',
          paddingLeft: '1rem',
          paddingRight: '1rem'
        }}>
          {/* First booking option */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '1.5rem',
            flexWrap: 'wrap',
            maxWidth: '900px',
            padding: '0 1rem'
          }}>
            <button
              style={{
                background: 'linear-gradient(135deg, rgba(201, 168, 76, 0.15) 0%, rgba(201, 168, 76, 0.05) 100%)',
                color: 'var(--gold-light)',
                border: '1.5px solid var(--gold)',
                padding: '14px 28px',
                borderRadius: '50px',
                fontSize: '0.9rem',
                fontFamily: 'var(--font-body)',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                whiteSpace: 'nowrap',
                letterSpacing: '0.06em',
                textTransform: 'uppercase',
                backdropFilter: 'blur(8px)'
              }}
              onMouseEnter={(e) => { e.target.style.boxShadow = '0 0 25px rgba(201, 168, 76, 0.2)'; e.target.style.transform = 'translateY(-2px)'; }}
              onMouseLeave={(e) => { e.target.style.boxShadow = 'none'; e.target.style.transform = 'translateY(0)'; }}
              onClick={scrollToDates}
            >
              Join a Scheduled Mystery
            </button>
            <p style={{
              color: 'var(--text-secondary)',
              fontSize: '0.95rem',
              fontFamily: 'var(--font-body)',
              lineHeight: '1.6',
              margin: '0',
              maxWidth: '400px',
              textAlign: 'center'
            }}>
              Book seats for our upcoming mystery events on pre-announced dates and solve the case with other guests.
            </p>
          </div>

          {/* OR separator */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
            width: '200px',
            margin: '0.5rem 0'
          }}>
            <div style={{ flex: 1, height: '1px', background: 'linear-gradient(90deg, transparent, rgba(201, 168, 76, 0.3))' }}></div>
            <span style={{
              fontSize: '1rem',
              fontFamily: 'var(--font-heading)',
              fontWeight: '600',
              color: 'var(--gold)',
              letterSpacing: '0.15em'
            }}>OR</span>
            <div style={{ flex: 1, height: '1px', background: 'linear-gradient(90deg, rgba(201, 168, 76, 0.3), transparent)' }}></div>
          </div>

          {/* Second booking option */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '1.5rem',
            flexWrap: 'wrap',
            maxWidth: '900px',
            padding: '0 1rem'
          }}>
            <button
              style={{
                background: 'linear-gradient(135deg, rgba(201, 168, 76, 0.15) 0%, rgba(201, 168, 76, 0.05) 100%)',
                color: 'var(--gold-light)',
                border: '1.5px solid var(--gold)',
                padding: '14px 28px',
                borderRadius: '50px',
                fontSize: '0.9rem',
                fontFamily: 'var(--font-body)',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                whiteSpace: 'nowrap',
                letterSpacing: '0.06em',
                textTransform: 'uppercase',
                backdropFilter: 'blur(8px)'
              }}
              onMouseEnter={(e) => { e.target.style.boxShadow = '0 0 25px rgba(201, 168, 76, 0.2)'; e.target.style.transform = 'translateY(-2px)'; }}
              onMouseLeave={(e) => { e.target.style.boxShadow = 'none'; e.target.style.transform = 'translateY(0)'; }}
              onClick={scrollToPrivateExperience}
            >
              Book a Private Mystery
            </button>
            <p style={{
              color: 'var(--text-secondary)',
              fontSize: '0.95rem',
              fontFamily: 'var(--font-body)',
              lineHeight: '1.6',
              margin: '0',
              maxWidth: '400px',
              textAlign: 'center'
            }}>
              Reserve the entire experience for your group on a date of your choice (subject to availability).
            </p>
          </div>
        </div>

      </section>

      {/* Where You'll Be */}
      <LocationMap location={location} />

      {/* Show Dates Section */}
      <section className="show-dates-section" ref={datesSectionRef}>
        <div className="show-dates-header">
          <h2>Select an Event Date</h2>
          <p className="dates-hint">
            To enquire about a specific date, select any card below to check
            availability directly with the organiser on WhatsApp.
          </p>
        </div>
        <div className="dates-grid">
          {showDates.map((date, index) => (
            <div
              key={index}
              className={`date-card is-enquirable${date.soldOut ? ' sold-out' : ''}${date.highlight ? ' highlight' : ''}`}
              role="button"
              tabIndex={0}
              aria-label={`Enquire about the ${formatDate(date)} mystery${date.soldOut ? ' (sold out)' : ''}`}
              onClick={() => setEnquiryDate(date)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  setEnquiryDate(date);
                }
              }}
            >
              <div className="date-card-img-wrapper">
                <img
                  src={date.image}
                  alt={`${date.label} ${date.day}`}
                  className="date-card-img"
                />
                <div className="date-badge">
                  <span className="date-badge-month">{date.month}</span>
                  <span className="date-badge-day">{date.day}</span>
                </div>
                {date.soldOut && (
                  <div className="sold-out-overlay">Sold Out</div>
                )}
              </div>
              <div className="date-card-label">{date.label}</div>
            </div>
          ))}
        </div>

        {/* WhatsApp Contact Section */}
        <div style={{ position: 'relative', zIndex: 1, padding: '3rem 2rem', maxWidth: '1200px', margin: '0 auto', textAlign: 'center' }}>
          <p style={{ fontFamily: 'Avenir', fontSize: '1.2rem', color: '#E8E3E3', marginBottom: '1.5rem', lineHeight: '1.8' }}>
            To book your experience for any date, contact us now on WhatsApp
          </p>
          <a
            href="https://wa.me/918279845322?text=Hi%20Mystery%20Mansion,%20I%20would%20like%20to%20book%20an%20experience"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.8rem',
              padding: '12px 28px',
              backgroundColor: '#25D366',
              color: '#FFFFFF',
              textDecoration: 'none',
              borderRadius: '8px',
              fontFamily: 'Avenir',
              fontWeight: '600',
              fontSize: '1rem',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => { e.currentTarget.style.opacity = '0.85'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.opacity = '1'; e.currentTarget.style.transform = 'translateY(0)'; }}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.064 3.488z" />
            </svg>
            +91 8279845322
          </a>
        </div>
      </section>

      {/* Private Experience Section */}
      <section className="show-dates-section" ref={privateExperienceSectionRef}>
        <div className="show-dates-header">
          <h2>Book a Private Mystery</h2>
        </div>
        <div style={{ position: 'relative', zIndex: 1, padding: '4rem 2rem', maxWidth: '1300px', margin: '0 auto' }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '4rem',
            flexWrap: 'wrap'
          }}>
            {/* Left side - Text content */}
            <div style={{ flex: 1, minWidth: '300px' }}>
              {/* Tagline */}
              <div style={{
                fontFamily: 'Avenir',
                fontSize: '1.5rem',
                fontWeight: '600',
                color: '#D4AF37',
                letterSpacing: '0.15em',
                marginBottom: '1rem',
                textTransform: 'uppercase'
              }}>
                Exclusive Group Experience
              </div>



              {/* Description */}
              <div style={{
                fontFamily: 'Avenir',
                fontSize: '1.1rem',
                lineHeight: '1.8',
                color: '#E8E3E3',
                maxWidth: '450px'
              }}>
                <p>Reserve the entire mansion for a private night of mystery and intrigue. With the complete experience dedicated to your group, you and your guests will step into an unfolding story filled with hidden clues, unexpected twists, and secrets waiting to be discovered.</p>
                <p>Choose your preferred date, gather your team of investigators, and work together to unravel the mystery before the night is over.</p>

              </div>
            </div>

            {/* Right side - Visual element */}
            <div style={{ flex: 1, minWidth: '300px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{
                position: 'relative',
                width: '100%',
                maxWidth: '450px',
                overflow: 'hidden',
                borderRadius: '16px',
                boxShadow: '0 16px 48px rgba(0, 0, 0, 0.5)',
                transition: 'all 0.4s ease',
                cursor: 'pointer'
              }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.02) translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 24px 64px rgba(0, 0, 0, 0.7)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1) translateY(0)';
                  e.currentTarget.style.boxShadow = '0 16px 48px rgba(0, 0, 0, 0.5)';
                }}>
                <img
                  src={seventeenthImg}
                  alt="Private mystery mansion experience"
                  style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block',
                    aspectRatio: '4 / 3',
                    objectFit: 'cover'
                  }}
                />
                {/* Overlay text */}
                <div style={{
                  position: 'absolute',
                  bottom: '0',
                  left: '0',
                  right: '0',
                  background: 'linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent)',
                  padding: '2rem 1.5rem 1.5rem',
                  color: '#FFFFFF',
                  fontFamily: 'Avenir',
                  fontSize: '0.95rem',
                  lineHeight: '1.6'
                }}>
                  Step into mystery. Uncover secrets. Create memories.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}